import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// Sin animaciones de label y borde: el selector vive en filas de tabla que se re-renderizan.
// Altura, borde, radio y fuente salen del tema (MuiOutlinedInput / MuiAutocomplete).
export const SelectChangeStatusFunnelStyle = styled.div`
  .MuiInputLabel-animated {
    transition: none !important;
  }

  .MuiInputBase-input {
    animation: none !important;
    animation-name: none !important;
  }

  .MuiOutlinedInput-notchedOutline legend {
    transition: none !important;
  }

  /* Placeholder como el texto de «Marcar como»: hace de etiqueta del selector, no de pista */
  .MuiInputBase-input::placeholder {
    color: ${tokens.color.text.secondary};
    opacity: 1;
  }

  /* Deshabilitado (sin candidaturas marcadas): texto y flecha en gris claro, como «Marcar como» y los
     botones de acciones; antes el placeholder seguía oscuro y parecía activo */
  .Mui-disabled .MuiInputBase-input::placeholder {
    color: ${tokens.color.text.disabled};
  }

  .Mui-disabled .MuiAutocomplete-popupIndicator {
    color: ${tokens.color.text.disabled};
  }
`
